export enum LanguageLevel {
	Basic = 'basic',
	Intermediate = 'intermediate',
	Advanced = 'advanced',
	Proficient = 'proficient',
}